import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LoadingTextComponent } from '@freelancer/components/loading-text';
import { CardComponent } from '@freelancer/ui/card';
import { LoadingAvatarComponent } from '@freelancer/ui/loading-avatar';
import { AvatarSize } from '@freelancer/ui/user-avatar';

@Component({
  standalone: true,
  imports: [
    CardComponent,
    LoadingAvatarComponent,
    LoadingTextComponent,
    NgTemplateOutlet,
  ],
  selector: 'fl-loading-avatar-row-card',
  template: `
    @if (card) {
      <fl-card>
        <ng-container [ngTemplateOutlet]="body" />
      </fl-card>
    } @else {
      <ng-container [ngTemplateOutlet]="body" />
    }

    <ng-template #body>
      <div
        class="Body"
        [class.Body--stacked]="stackOnMobile"
      >
        <!-- TODO: T333982 - Replace the fixed 152px wrapper with the real avatar
             dimensions once design confirms the spec. -->
        <div
          class="Avatar"
          [class.Avatar--max]="avatarSize === AvatarSize.MAX"
        >
          <fl-loading-avatar
            [size]="avatarSize"
            [sizeDesktop]="avatarSizeDesktop"
          />
        </div>
        @if (stackOnMobile) {
          <fl-loading-text
            class="Body-header"
            [rows]="headerRows"
          />
        }
        <fl-loading-text
          class="Body-body"
          [rows]="bodyRows"
        />
      </div>
    </ng-template>
  `,
  styleUrls: ['./loading-avatar-row-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingAvatarRowCardComponent {
  AvatarSize = AvatarSize;

  @Input() avatarSize: AvatarSize = AvatarSize.MAX;

  /**
   * Optional avatar size applied from the desktop breakpoint up. Leave unset to
   * keep `avatarSize` at all breakpoints.
   */
  @Input() avatarSizeDesktop?: AvatarSize;

  /** Rows of loading text rendered alongside the avatar. */
  @Input() bodyRows = 2;

  /**
   * On mobile, show the header text beside the avatar and wrap the body text
   * full-width underneath. On desktop it stays a single row (avatar + body).
   */
  @Input() stackOnMobile = false;

  /**
   * Rows of loading text rendered beside the avatar in the stacked (mobile)
   * layout, mirroring the user's name/details. Only used when `stackOnMobile`.
   */
  @Input() headerRows = 2;

  /** Wrap the avatar row in an `fl-card`. Set `false` when the parent surface already provides its own card/background. */
  @Input() card = true;
}
